import { render } from "./VoiceDictation.vue?vue&type=template&id=765c8b5b&scoped=true&ts=true"
import script from "./VoiceDictation.vue?vue&type=script&lang=ts"
export * from "./VoiceDictation.vue?vue&type=script&lang=ts"

import "./VoiceDictation.vue?vue&type=style&index=0&id=765c8b5b&scoped=true&lang=css"

import exportComponent from "../../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765c8b5b"]])

export default __exports__